import { createApp } from 'vue'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue'
import router from './router/index.js';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { createStore } from 'vuex';
import VueLazyload from 'vue-lazyload'
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

// 根据环境设置uploadUrl
let uploadUrl = '/upload'; // 生产环境使用相对路径

if (process.env.NODE_ENV === 'development') {
    uploadUrl = '/upload'; // 开发环境通过代理访问
}

const store = createStore({
    state: {
        adminUsername: '',
        adminRealname: '',
        role: 0,
        shopid: 0,
        shopname: ''
    },
    mutations: {
        SET_ADMIN_USERNAME(state, username) {
            state.adminUsername = username;
        },
        SET_ADMIN_REALNAME(state, realname) {
            state.adminRealname = realname;
        },
        SET_ROLE(state, role) {
            state.role = role;
        },
        SET_SHOPID(state, shopid) {
            state.shopid = shopid;
        },
        SET_SHOPNAME(state, shopname) {
            state.shopname = shopname;
        }
    },
    getters: {
        adminUsername: state => state.adminUsername,
        adminRealname: state => state.adminRealname,
        role: state => state.role,
        shopid: state => state.shopid,
        shopname: state => state.shopname,
    },
    actions: {
        checkAdminRole({ state, $router }) {
            const role = parseInt(state.role);
            if (role > 0) {
                localStorage.removeItem('admin_login_info');
                $router.push('/adminlogin');
            }
        }
    }
});
const app = createApp(App)
app.config.globalProperties.$uploadURL = uploadUrl
Object.entries(ElementPlusIconsVue).forEach(([key, component]) => {
  app.component(key, component);
});
// 注册vue-json-excel组件
app.use(ElementPlus, { zIndex: 3000, locale: zhCn }).use(router).use(store).use(VueLazyload, {
  preLoad: 1.3,
//   error: 'path/to/error-image.png',
  loading: '/images/loading.gif' ,
  attempt: 3
}).mount('#app')
app.mixin({
    methods: {
        formatDate(value, method = 'UTC') {
            let date = new Date(value);
            if (method == 'UTC') {
                let year = date.getUTCFullYear();
                let month = String(date.getUTCMonth() + 1).padStart(2, '0');
                let day = String(date.getUTCDate()).padStart(2, '0');
                let hours = String(date.getUTCHours()).padStart(2, '0');
                let minutes = String(date.getUTCMinutes()).padStart(2, '0');
                let seconds = String(date.getUTCSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } else {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，加1后转为字符串并补0
                const day = String(date.getDate()).padStart(2, '0'); // 日期转为字符串并补0
                const hours = String(date.getHours()).padStart(2, '0'); // 小时转为字符串并补0
                const minutes = String(date.getMinutes()).padStart(2, '0'); // 分钟转为字符串并补0
                const seconds = String(date.getSeconds()).padStart(2, '0'); // 秒转为字符串并补0
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
        },
        // 金额计算统一保留两位，避免小数价格相乘出现 6.300000000000001 之类浮点误差
        money(value) {
            const n = Number(value);
            if (!isFinite(n)) return 0;
            return Math.round((n + Number.EPSILON) * 100) / 100;
        },
        readOrderStatus(status) {
            const statusMap = {
                0: '已下单',
                1: '已打票',
                2: '已出餐，正在配送中',
                3: '已取消',
                4: '已送达'
            };
            return statusMap[status] || '';
        },
    },

})